import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
const MobileApplicationFaq = () => {
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleItem = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const toggleAll = () => {
    if (openIndexes.length === faqData.length) {
      setOpenIndexes([]);
    } else {
      setOpenIndexes(faqData.map((_, i) => i));
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const faqData = [
    {
      question: "What is mobile app development?",
      answer:
        "Mobile app development is the process of creating software applications that run on mobile devices such as smartphones and tablets. These apps are designed to provide functionality and improve user experience.",
    },
    {
      question: "Why should I develop a mobile app for my business?",
      answer:
        "A mobile app can improve customer engagement, enhance user experience, and offer more direct communication channels, all while providing a seamless service on-the-go for your customers.",
    },
    {
      question: "What platforms can I develop my mobile app on?",
      answer:
        "You can develop mobile apps for iOS, Android, or both, depending on your target audience and business needs. Cross-platform solutions like React Native and Flutter allow development for both platforms simultaneously.",
    },
    {
      question: "How do mobile apps enhance customer experience?",
      answer:
        "Mobile apps provide personalized experiences, faster access to services, and seamless interactions, such as push notifications, location-based features, and offline capabilities, improving user satisfaction and retention.",
    },
  ];

  return (
    <div className="bg-white py-8">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
          <div className="w-full text-center md:pb-10">
            <h2 className="text-xl md:text-3xl font-semibold text-main">
              Frequently Asked Questions (Faq)
            </h2>
            <div className="border-b-4 border-main w-20 md:w-40 mx-auto my-2 rounded-full" />
          </div>

          <button
            onClick={toggleAll}
            className="text-sm font-medium text-black underline hover:text-blue-700 whitespace-nowrap sm:self-end"
          >
            {openIndexes.length === faqData.length
              ? "Collapse all"
              : "Expand all"}
          </button>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-xl shadow-sm overflow-hidden"
              data-aos="fade-up"
            >
              <button
                onClick={() => toggleItem(index)}
                className="w-full bg-primaryPri flex justify-between items-center px-6 py-4 text-left"
              >
                <p className="md:text-lg text-sm font-medium text-black">
                  {item.question}
                </p>

                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={`w-3 h-3 transform transition-transform ${
                    openIndexes.includes(index) ? "rotate-180" : ""
                  }`}
                />
              </button>

              {openIndexes.includes(index) && (
                <div
                  className="px-6 pb-4 text-gray-700 text-xs md:text-sm"
                  data-aos="fade-down"
                >
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MobileApplicationFaq;
